import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAllBills } from '../../api';
import styles from './BillingHistory.module.css';

const BillingHistory = () => {
  const [bills, setBills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBills = async () => {
      try {
        setLoading(true);
        const userEmail = localStorage.getItem('userEmail');
        const data = await getAllBills(userEmail);
        // Ensure we have an array and filter out any invalid entries
        const validBills = Array.isArray(data) ? data.filter(bill => bill && typeof bill === 'object') : [];
        setBills(validBills);
        setError(null);
      } catch (err) {
        setError('Failed to load billing history');
        console.error('Error fetching bills:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBills();
  }, []);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleBack = () => {
    navigate('/user/dashboard');
  };

  if (loading) {
    return (
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.loadingContainer}>
            <h2 className={styles.loadingText}>Loading billing history...</h2>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.header}>
          <h1 className={styles.title}>Billing History</h1>
          <button
            onClick={handleBack}
            className={styles.backButton}
          >
            Back to Dashboard
          </button>
        </div>

        <div className={styles.mainContent}>
          {error && (
            <div className={styles.errorMessage}>
              {error}
            </div>
          )}

          {bills.length === 0 ? (
            <div className={styles.emptyState}>
              <h3>No billing history found</h3>
              <p>You don't have any bills yet.</p>
            </div>
          ) : (
            <div className={styles.tableContainer}>
              <table className={styles.table}>
                <thead className={styles.tableHeader}>
                  <tr>
                    <th>Patient Name</th>
                    <th>Doctor Name</th>
                    <th>Date & Time</th>
                    <th>Fees</th>
                  </tr>
                </thead>
                <tbody>
                  {bills.map((bill, index) => (
                    <tr key={bill._id || index} className={styles.tableRow}>
                      <td className={styles.tableCell}>{bill.patientName}</td>
                      <td className={styles.tableCell}>{bill.doctorName}</td>
                      <td className={styles.tableCell}>{formatDate(bill.dateTime)}</td>
                      <td className={`${styles.tableCell} ${styles.feesCell}`}>
                        {new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(Number(bill.fees || 0))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BillingHistory; 